import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';

export const PrivacyPrincipleSchema = BigdesDefinitionSchema.extend({});
export const CreatePrivacyPrincipleSchema = PrivacyPrincipleSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdatePrivacyPrincipleSchema = PrivacyPrincipleSchema.partial();
